(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@tencent/hymixed-pcapi"] = factory();
	else
		root["@tencent/hymixed-pcapi"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_USER_PROFILE", function() { return HY_USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_PHOTO_CLIP", function() { return HY_PHOTO_CLIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_USER_ALBUM", function() { return HY_USER_ALBUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_PAY", function() { return HY_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_PAY_MIDAS", function() { return HY_PAY_MIDAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_PHOTO_VIEWER", function() { return HY_PHOTO_VIEWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_SECOND_INDENTITY_EDITOR", function() { return HY_SECOND_INDENTITY_EDITOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_USER_PROFILE_FOLLOW", function() { return HY_USER_PROFILE_FOLLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_USER_PROFILE_FOLLOWME", function() { return HY_USER_PROFILE_FOLLOWME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_USER_PROFILE_CHARM", function() { return HY_USER_PROFILE_CHARM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_PHONE_VERIFICATION", function() { return HY_PHONE_VERIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_VOICE_COVER", function() { return HY_VOICE_COVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_LEVEL", function() { return HY_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_TASK", function() { return HY_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_PRIVILEGE", function() { return HY_PRIVILEGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_BADGE_LIST", function() { return HY_BADGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HY_APITEST", function() { return HY_APITEST; });
var HY_USER_PROFILE = 'HY_USER_PROFILE';

// 裁剪图片
var HY_PHOTO_CLIP = {
    ALBUM: 'HY_PHOTO_CLIP_ALBUM',
    COVER: 'HY_PHOTO_CLIP_COVER',
    AVATAR: 'HY_PHOTO_CLIP_AVATAR',
    toString: function toString() {
        return 'HY_PHOTO_CLIP';
    }

    // 用户相册
};var HY_USER_ALBUM = 'HY_USER_ALBUM';

// 充值
var HY_PAY = 'HY_PAY';
// 米大师充值
var HY_PAY_MIDAS = 'HY_PAY_MIDAS';

// 照片查看器
var HY_PHOTO_VIEWER = 'HY_PHOTO_VIEWER';

// 第二身份编辑页
var HY_SECOND_INDENTITY_EDITOR = 'HY_SECOND_INDENTITY_EDITOR';

// 我关注的人
var HY_USER_PROFILE_FOLLOW = 'HY_USER_PROFILE_FOLLOW';

// 关注我的人
var HY_USER_PROFILE_FOLLOWME = 'HY_USER_PROFILE_FOLLOWME';

// 魅力值排行榜
var HY_USER_PROFILE_CHARM = 'HY_USER_PROFILE_CHARM';

// 手机认证
var HY_PHONE_VERIFICATION = 'HY_PHONE_VERIFICATION';

// 语音封面
var HY_VOICE_COVER = 'HY_VOICE_COVER';

// 我的等级
var HY_LEVEL = 'HY_LEVEL';

// 任务
var HY_TASK = 'HY_TASK';

// 爵位
var HY_PRIVILEGE = 'HY_PRIVILEGE';

// 勋章
var HY_BADGE_LIST = 'HY_BADGE_LIST';

// 测试接口
var HY_APITEST = 'HY_APITEST';

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["loadPageConfig"] = loadPageConfig;
/* harmony export (immutable) */ __webpack_exports__["addQuery"] = addQuery;
/* harmony export (immutable) */ __webpack_exports__["callApi"] = callApi;
/* harmony export (immutable) */ __webpack_exports__["createCallback"] = createCallback;
/* harmony export (immutable) */ __webpack_exports__["callApiTencent"] = callApiTencent;
/* harmony export (immutable) */ __webpack_exports__["OpenTencentUri"] = OpenTencentUri;
/* harmony export (immutable) */ __webpack_exports__["GetCurrentHostUid"] = GetCurrentHostUid;
/* harmony export (immutable) */ __webpack_exports__["GetCurrentRoomId"] = GetCurrentRoomId;
/* harmony export (immutable) */ __webpack_exports__["DragWindow"] = DragWindow;
/* harmony export (immutable) */ __webpack_exports__["UpdateBalance"] = UpdateBalance;
/* harmony export (immutable) */ __webpack_exports__["OpenChargeWindow"] = OpenChargeWindow;
/* harmony export (immutable) */ __webpack_exports__["ShowWindows"] = ShowWindows;
/* harmony export (immutable) */ __webpack_exports__["ShowActivityWindows"] = ShowActivityWindows;
/* harmony export (immutable) */ __webpack_exports__["ShowLayerWindows"] = ShowLayerWindows;
/* harmony export (immutable) */ __webpack_exports__["Show"] = Show;
/* harmony export (immutable) */ __webpack_exports__["Hide"] = Hide;
/* harmony export (immutable) */ __webpack_exports__["Close"] = Close;
/* harmony export (immutable) */ __webpack_exports__["Minimize"] = Minimize;
/* harmony export (immutable) */ __webpack_exports__["OpenUserInfoCard"] = OpenUserInfoCard;
/* harmony export (immutable) */ __webpack_exports__["GetLayoutByName"] = GetLayoutByName;
/* harmony export (immutable) */ __webpack_exports__["RegisterJsPush"] = RegisterJsPush;
/* harmony export (immutable) */ __webpack_exports__["UnRegisterJsPush"] = UnRegisterJsPush;
/* harmony export (immutable) */ __webpack_exports__["ShowDialog"] = ShowDialog;
/* harmony export (immutable) */ __webpack_exports__["ShowTips"] = ShowTips;
/* harmony export (immutable) */ __webpack_exports__["ShowMiniCard"] = ShowMiniCard;
/* harmony export (immutable) */ __webpack_exports__["HideMiniCard"] = HideMiniCard;
/* harmony export (immutable) */ __webpack_exports__["GetWindowSizeAndPosition"] = GetWindowSizeAndPosition;
/* harmony export (immutable) */ __webpack_exports__["SetWindowSizeAndPosition"] = SetWindowSizeAndPosition;
/* harmony export (immutable) */ __webpack_exports__["AddImage"] = AddImage;
/* harmony export (immutable) */ __webpack_exports__["SetWebViewSize"] = SetWebViewSize;
/* harmony export (immutable) */ __webpack_exports__["showPage"] = showPage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pageNames", function() { return pageNames; });
/* harmony export (immutable) */ __webpack_exports__["Pay"] = Pay;
/* harmony export (immutable) */ __webpack_exports__["PayMidas"] = PayMidas;
/* harmony export (immutable) */ __webpack_exports__["UpdateUser"] = UpdateUser;
/* harmony export (immutable) */ __webpack_exports__["ExpandRankList"] = ExpandRankList;
/* harmony export (immutable) */ __webpack_exports__["EmitClientEvent"] = EmitClientEvent;
/* harmony export (immutable) */ __webpack_exports__["OnClientEvent"] = OnClientEvent;
/* harmony export (immutable) */ __webpack_exports__["OffClientEvent"] = OffClientEvent;
/* harmony export (immutable) */ __webpack_exports__["GetUin"] = GetUin;
/* harmony export (immutable) */ __webpack_exports__["OpenRoom"] = OpenRoom;
/* harmony export (immutable) */ __webpack_exports__["OpenMenu"] = OpenMenu;
/* harmony export (immutable) */ __webpack_exports__["GetRoomInfo"] = GetRoomInfo;
/* harmony export (immutable) */ __webpack_exports__["GetClientVersion"] = GetClientVersion;
/* harmony export (immutable) */ __webpack_exports__["CompareVersion"] = CompareVersion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_names__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsPush_jiaoyou__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsPush_jiaoyou___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jsPush_jiaoyou__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cookie__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver_compare__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver_compare__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






// 是否在Node环境
var isNode = typeof window === 'undefined';

// let configMap = {}
function loadPageConfig(config) {
    for (var key in config) {
        __WEBPACK_IMPORTED_MODULE_1__page_names__[key] = key;
        __WEBPACK_IMPORTED_MODULE_0__page_config__["a" /* default */][key] = config[key];
    }
}

/**
 * 给url添加query
 * @param {String} url
 * @param {String} key
 * @param {String} value
 *
 * @return {String} url
 */
function addQuery(url, key, value) {
    if (!key || !value && value !== 0) {
        return url;
    }

    url += (~url.indexOf('?') ? '&' : '?') + (key + '=' + value);
    return url;
}

/**
 * 调window.external下的客户端接口
 * @param {String} apiName 接口名
 * @param {rest} params 任意接口参数
 */
function callApi(apiName) {
    var _window$external;

    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
    }

    console.log(params);

    if (isNode) {
        return;
    }

    if (!window.external) {
        console.warn('api must run in HuaYang Client');
        return;
    }

    if (!window.external[apiName]) {
        console.warn('No such api: ' + apiName);
        return;
    }

    return (_window$external = window.external)[apiName].apply(_window$external, params);
}

/**
 * 生成一个回调函数名
 * @param apiName
 * @param callback
 */
function createCallback(apiName, callback) {
    var callbackName = '__HY_callback_' + apiName + '_' + +new Date();

    window[callbackName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        callback.apply(null, args);
        // delete window[callbackName]      // 暂时不delete了
    };
    return callbackName;
}

/**
 * 调tencent串
 */
function callApiTencent(url) {
    if (isNode) {
        return;
    }

    var iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.height = 0;
    iframe.width = 0;
    iframe.style.cssText = 'display: none';

    document.body.appendChild(iframe);

    setTimeout(function () {
        document.body.removeChild(iframe);
        iframe = null;
    }, 2000);
}

/**
 * 打开tencent串，该接口为客户端提供
 * @param {String} url tencent://后边的部分
 *
 * @support 花样交友PC
 */
function OpenTencentUri(url) {
    return callApi('OpenTencentUri', url);
}

/**
 * 取得当前主持人的uid
 *
 * @return {String} 当前主持人的uid，如果不存在主持人则为""
 *
 * @support 花样交友PC
 */
function GetCurrentHostUid() {
    return callApi('GetCurrentHostUid');
}

/**
 * 取得当前房间号
 *
 * @return {String} 当前房间号
 *
 * @support 花样交友PC
 */
function GetCurrentRoomId() {
    return callApi('GetCurrentRoomId');
}

/**
 * 移动窗口，可以在需要移动的dom元素上的mousedown handler里边调用该函数即可以移动
 *
 * activityWindow专用
 * activityWindow参考：http://git.code.oa.com/jichaoyang/od-layer-demos/wikis/activityWindows
 *
 * @support 花样交友PC
 */
function DragWindow() {
    return callApi('DragWindow');
}

/**
 * 更新pc端余额
 *
 * @support 花样交友PC
 */
function UpdateBalance() {
    return callApi('UpdateBalance');
}

/**
 * ！已废弃，仅供老交友充值暂时调用
 * 打开交友充值页面
 * @param {String} queryString 传给充值页面的query查询串，一些老的活动窗口不支持这个参数
 *
 * queryString 可接收参数：
 * 1）list，指定充值花豆数
 * 2）pf，指定充值来源
 *
 * queryString示例：'list=10&pf=test'
 *
 * @support 花样交友PC
 */
function OpenChargeWindow(queryString) {
    console.warn('该接口已废弃，请调用新充值接口');
    return callApi('OpenChargeWindow', queryString);
}

/**
 * 打开窗口（老接口）
 *
 * @param {String} cfg json字符串，格式与后台配置的action_config一样
 *
 * @example
 * cfg示例："{\"embedWindows\":[{\"id\":\"keke\",\"url\":\"http://qvideo.qq.com/jiaoyou_pc/activity/act912.html\",\"width\":240,\"height\":255,\"topMargin\":0,\"bottomMargin\":0,\"initHide\":true}]}"
 *
 * @support 花样交友PC
 */
function ShowWindows(cfg) {
    if ((typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) === 'object') {
        cfg = JSON.stringify(cfg);
    }
    return callApi('ShowWindows', cfg);
}

/**
 * 打开窗口（Activity）
 * @param {Object} config
 */
function ShowActivityWindows(config) {
    if (!config.url) {
        throw new Error('url is required');
    }
    var defaultConfig = {
        id: 'hy-page-' + +new Date(),
        title: '花样交友',
        width: 800,
        height: 600,
        modal: false
    };

    if (config.pageShadow) {
        config.width = config.width + 16;
        config.height = config.height + 100; // 避免部分页面高度滚动
    }

    // 处理url的query
    var url = config.url,
        query = config.query;

    if (query) {
        if (url.indexOf('?') === -1) {
            // url中没有参数
            url += '?';
        } else {
            // 有参数
            url += '&';
        }

        var querystring = '';
        for (var key in query) {
            querystring += key + '=' + query[key] + '&';
        }

        url += querystring;
        url = url.replace(/&$/, '');
    }

    // 如果以 // 开头，添加 https 头
    if (url.slice(0, 2) === '//') {
        url = 'https:' + url;
    }

    config.url = url;

    // window.external.ShowWindow("{\"type\":\"PopUpWindow\",\"title\":\"测试\",\"url\":\"file:///F:\\\\VIB\\\\test.html?\",\"width\": 800,\"height\":600,\"id\":\"profile\"}","cb");
    return callApi('ShowWindow', JSON.stringify(_extends({}, defaultConfig, config, {
        type: 'PopUpWindow'
    })), 'cb');
}

/**
 * 打开窗口（Layer）
 * @param {Object} config
 */
function ShowLayerWindows(config) {
    if (!config.url) {
        throw new Error('url is required');
    }
    var defaultConfig = {
        id: 'hy-page-' + +new Date(),
        status: 0,
        queue_type: 0,
        timeout: 0,
        layoutType: 'adaptive',
        horzAlign: 'middleAlign',
        vertAlign: 'middleAlign',
        width: 100,
        height: 100,
        offsetx: 0,
        offsety: 0,
        nativeWidgetName: 'ContainerWnd',
        initHide: true
    };
    console.log(config);
    ShowWindows({
        v2: {
            layers: [_extends({}, defaultConfig, config)]
        }
    });
}

/**
 * 显示当前窗口
 *
 * @support 花样交友PC
 */
function Show() {
    return callApi('Show');
}

/**
 * 隐藏当前窗口
 *
 * @support 花样交友PC
 */
function Hide() {
    return callApi('Hide');
}

/**
 * 关闭当前窗口
 *
 * @support 花样交友PC
 */
function Close() {
    return callApi('Close');
}
/**
 * 最小化窗口
 */
function Minimize() {
    return callApi('Minimize', '');
}

/**
 * 打开个人资料卡
 *
 * @param {String} uin 用户Q号
 *
 * @support 花样交友PC
 */
function OpenUserInfoCard(uin) {
    return callApi('OpenUserInfoCard', uin + '');
}

/**
 * 根据名字取得pc端某个控件的rect
 *
 * @param {String} name 控件名
 *
 * @return {String} 该控件的rect的字符串, 如"100,200,300,400"
 *
 * @support 花样交友PC
 */
function GetLayoutByName(name) {
    return callApi('GetLayoutByName', name);
}

/**
 * 注册jspush的回调
 *
 * @param {String} eventName jspush的事件名
 *
 * 示例：RegisterJsPush("HostChanged")，则主持人发生变化的时候，该窗口会收到push，调用页面的OnJsPushCallback函数
 *
 * @support 花样交友PC
 */
function RegisterJsPush(eventName) {
    console.log('暂时不要用这个接口，先用jsPush_jiaoyou.js代替');
    return callApi('RegisterJsPush', eventName);
}

/**
 * 反注册jspush的回调
 *
 * @param {String} eventName jspush的事件名
 *
 * 示例：UnRegisterJsPush("HostChanged")，反注册之后就不会收到回调了
 *
 * @support 花样交友PC
 */
function UnRegisterJsPush(eventName) {
    return callApi('UnRegisterJsPush', eventName);
}

/* ---------------下面都是整合新加入的api------------ */

/**
 * 唤起一个对话框
 * @param param {Object}
 * @param callback  {String}
 */
function ShowDialog(param, callback) {
    var callbackName = createCallback('ShowDialog', function (res) {
        // 客户端返回的是字符串，这里要解析一下。
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });
    return callApi('ShowDialog', JSON.stringify(param), callbackName);
}

/**
 * 唤起一个tips
 * @param param {Object}
 */
function ShowTips(param) {
    return callApi('ShowTips', JSON.stringify(param));
}

/**
 * 唤起迷你资料卡
 * @param {Object} config - 配置项
 * 
 * @example
 * ShowMiniCard({
 *     uid,   // uid
 *     x,     // 以webview左顶端为原点的X位置
 *     y,     // 以webview左顶端为原点的y位置
 *     relative: {
 *         direction: 'horizontal',  // 资料卡相对于webview的方位，'horizontal':出现在webview左边， 'vertical': 出现在webview下面
 *         side: 'edge'  // 'edge': 水平方位 左对齐， 竖直方向 上对齐 ;  'center'相应方向居中对齐
 *    },
 *    margin: {
 *        vertical: 0, // 竖直方向偏移量
 *        horizontal: 5 // 水平方向偏移量
 *   }
 * })
 */
function ShowMiniCard(param) {
    return callApi('ShowMiniCard', JSON.stringify(param));
}

/**
 * 关闭迷你资料卡
 */
function HideMiniCard() {
    return callApi('HideMiniCard');
}

/**
 * 获取窗口宽高和位置
 * @param param {Object}
 */
function GetWindowSizeAndPosition(param, callback) {
    var callbackName = createCallback('GetWindowSizeAndPosition', function (res) {
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });
    return callApi('GetWindowSizeAndPosition', JSON.stringify(param), callbackName);
}

/**
 * 设置窗口宽高和位置
 */
function SetWindowSizeAndPosition(param, callback) {
    var callbackName = createCallback('SetWindowSizeAndPosition', function (res) {
        // 客户端返回的是字符串，这里要解析一下。
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });
    return callApi('SetWindowSizeAndPosition', JSON.stringify(param), callbackName);
}

/**
 * 读取图片
 */
function AddImage(callback) {
    var callbackName = createCallback('AddImage', function (res) {
        // 客户端返回的是字符串，这里要解析一下。
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });
    return callApi('AddImage', callbackName);
}

/**
 * 设置内嵌页宽高
 * @param param {Object}
 */
function SetWebViewSize(param, callback) {
    var callbackName = createCallback('SetWebViewSize', function (res) {
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });
    return callApi('SetWebViewSize', JSON.stringify(param), callbackName);
}

/**
 * 打开某页
 *
 * @param pageName {String}
 * 在'page/names.js'中配置页面名称 - 在'page/config.js'中配置页面的类型、宽高等其他属性
 *
 * @param options {Object}
 * 页面配置，如果不填，则使用默认值，默认值参见 ShowActivityWindows 和 ShowLayerWindows 这两个方法，配置项参考：http://git.code.oa.com/jichaoyang/od-layer-demos/wikis/pages
 */
function showPage(pageName, options) {
    if (!__WEBPACK_IMPORTED_MODULE_0__page_config__["a" /* default */][pageName]) {
        throw new Error('invalid id');
    }
    var config = __WEBPACK_IMPORTED_MODULE_0__page_config__["a" /* default */][pageName];
    if (config.type === 'layer') {
        ShowLayerWindows(_extends({
            id: pageName
        }, config, options));
    } else {
        ShowActivityWindows(_extends({
            id: pageName
        }, config, options));
    }
}

var pageNames = __WEBPACK_IMPORTED_MODULE_1__page_names__;

/**
 * 打开充值浮层，这个浮层可以选择选择充值金额，选择了具体金额点充值才会走到真正的米大师充值界面
 * @param {String} from 充值调用方，会上报到充值的tdbank
 * @param {String} pf 自定义充值pf，可以用于区分充值来源。不传默认是huyu_m-2001-html5-2011-hylovepch5或qq_m_qq-2001-html5-2011-hylovepch5，传了值的话，会加在huyu_m-2001-html5-2011-后面，如传了hypayact，最后充值的pf值是huyu_m-2001-html5-2011-hypayact
 * @param {Number} isTopMost 设置弹窗是否置顶，1置顶 0默认
 */
function Pay() {
    var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var pf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var isTopMost = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var pageName = __WEBPACK_IMPORTED_MODULE_1__page_names__["HY_PAY"],
        config = __WEBPACK_IMPORTED_MODULE_0__page_config__["a" /* default */][pageName];

    config.query = {
        from: from,
        pf: pf
    };

    return ShowActivityWindows(_extends({
        id: pageName
    }, config, {
        isTopMost: isTopMost
    }));
}

/**
 * 调用米大师充值指定金额
 * @param {Number} payNum 充值金额
 * @param {String} from 充值调用方
 * @param {String} pf 自定义充值pf，可以用于区分充值来源。不传默认是huyu_m-2001-html5-2011-hylovepch5或qq_m_qq-2001-html5-2011-hylovepch5，传了值的话，会加在huyu_m-2001-html5-2011-后面，如传了hypayact，最后充值的pf值是huyu_m-2001-html5-2011-hypayact
 * @param {Number} isTopMost 设置弹窗是否置顶，1置顶 0默认
 */
function PayMidas(payNum) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var pf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var isTopMost = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var pageName = __WEBPACK_IMPORTED_MODULE_1__page_names__["HY_PAY_MIDAS"],
        config = __WEBPACK_IMPORTED_MODULE_0__page_config__["a" /* default */][pageName];

    config.query = {
        paynum: payNum,
        from: from,
        pf: pf
    };

    return ShowActivityWindows(_extends({
        id: pageName
    }, config, {
        isTopMost: isTopMost
    }));
}

function UpdateUser(uid) {
    return callApi('UpdateUser', uid);
}

function ExpandRankList(param) {
    return callApi('ExpandRankList', JSON.stringify(param));
}

function makeInvalidArgTypeError(name, expect, received) {
    var msg = 'The "' + name + '" argument must be of type ' + expect + '.';
    if (received) {
        msg += ' Received type ' + received;
    }
    return new TypeError(msg);
}

/**
 * 发送事件
 * @param {String} eventName 事件名
 * @param {Object} data 传输的数据对象
 * @param {Object} options 配置对象，echo：本页面是否能收到事件，broadcast：是否广播给其它webview，设为false则只有当前页能收到
 */
function EmitClientEvent(eventName, data, options) {
    if (typeof eventName !== 'string') {
        throw makeInvalidArgTypeError('eventName', 'string', typeof eventName === 'undefined' ? 'undefined' : _typeof(eventName));
    }
    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
        throw makeInvalidArgTypeError('data', 'object', typeof data === 'undefined' ? 'undefined' : _typeof(data));
    }
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
        throw makeInvalidArgTypeError('options', 'object', typeof options === 'undefined' ? 'undefined' : _typeof(options));
    }

    options = _extends({
        echo: true,
        broadcast: true
    }, options);
    window.external.DispatchEvent(eventName, JSON.stringify(data), JSON.stringify(options));
}

/**
 * 监听事件
 * @param {String} eventName 事件名
 * @param {Function} callback 回调函数
 */
function OnClientEvent(eventName, callback) {
    if (typeof eventName !== 'string') {
        throw makeInvalidArgTypeError('eventName', 'string', typeof eventName === 'undefined' ? 'undefined' : _typeof(eventName));
    }
    if (typeof callback !== 'function') {
        throw makeInvalidArgTypeError('callback', 'function', typeof callback === 'undefined' ? 'undefined' : _typeof(callback));
    }
    __WEBPACK_IMPORTED_MODULE_2__jsPush_jiaoyou___default.a.$on(eventName, function (data) {
        callback(data);
    });
}

/**
 * 取消监听
 * @param {String} eventName 事件名
 */
function OffClientEvent(eventName) {
    if (typeof eventName !== 'string') {
        throw makeInvalidArgTypeError('eventName', 'string', typeof eventName === 'undefined' ? 'undefined' : _typeof(eventName));
    }
    __WEBPACK_IMPORTED_MODULE_2__jsPush_jiaoyou___default.a.$off(eventName);
}

/**
 * 获取当前用户的uin
 * @param {Function}    callback    回调函数
 */
function GetUin(callback) {
    var callbackName = createCallback('GetUin', function (res) {
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });
    return callApi('GetUin', callbackName);
}

/**
 * 进入房间
 * @param {String}  roomNo      交友房间号。值为"1"表示使用群号进房
 * @param {String}  uin         当前用户uin
 * @param {String}  gc          群号。roomNo为"1"时才使用
 * @param {Function}    callback       进房处理结束后的事件回调
 */
function OpenRoom(roomNo, uin, gc, callback) {
    var callbackName = createCallback('OnJsOpenRoomCallback', function (res) {
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });

    return callApi('OpenRoom', roomNo, uin, gc, callbackName);
}

function OpenMenu(param) {
    return callApi('OpenMenu', JSON.stringify(param));
}

/**
 * 获取房间信息
 * @param {Function}    callback    回调函数
 */
function GetRoomInfo(callback) {
    var callbackName = createCallback('GetRoomInfo', function (res) {
        res = typeof res === 'string' ? JSON.parse(res) : res;
        callback && callback(res);
    });
    return callApi('GetRoomInfo', callbackName);
}

/**
 * 获取客户端版本号
 * @returns {String} version 版本号，例如 "1.2.3"
 */
function GetClientVersion() {
    return __WEBPACK_IMPORTED_MODULE_3_cookie___default.a.parse(document.cookie).clientversion;
}

/**
 * 对比semver版本
 * @param {Strings} version1
 * @param {Strings} version2
 * @returns {Number} 对比结果：1代表大于, 0代表相等, -1代表小于
 */
function CompareVersion(version1, version2) {
    return __WEBPACK_IMPORTED_MODULE_4_semver_compare___default()(version1, version2);
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__names__ = __webpack_require__(0);
var _names$HY_USER_PROFIL;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var protocol = window.document.location.protocol || 'https:';

/* harmony default export */ __webpack_exports__["a"] = (_names$HY_USER_PROFIL = {}, _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_USER_PROFILE"], {
    type: 'activity',
    title: '个人资料页',
    url: 'https://qvideo.qq.com/mixed/pc/user-profile.html',
    width: 360,
    height: 562,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PHOTO_CLIP"].COVER, {
    type: 'activity',
    title: '语音封面',
    url: 'https://qvideo.qq.com/mixed/pc/photo-clip.html?type=cover',
    width: 360,
    height: 480,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PHOTO_CLIP"].AVATAR, {
    type: 'activity',
    title: '编辑照片',
    url: 'https://qvideo.qq.com/mixed/pc/photo-clip.html?type=avatar',
    width: 360,
    height: 480,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PHOTO_CLIP"].ALBUM, {
    type: 'activity',
    title: '编辑照片',
    url: 'https://qvideo.qq.com/mixed/pc/photo-clip.html?type=album',
    width: 360,
    height: 480,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_USER_ALBUM"], {
    type: 'activity',
    title: '我的相册',
    url: 'https://qvideo.qq.com/mixed/pc/album.html',
    width: 360,
    height: 470,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PAY"], {
    type: 'activity',
    title: '充值',
    url: 'https://qvideo.qq.com/mixed/pc/pay.html',
    width: 496,
    height: 396
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PAY_MIDAS"], {
    type: 'activity',
    title: '米大师支付',
    url: 'https://qvideo.qq.com/mixed/pc/pay-midas.html',
    width: 690,
    height: 589, // 628带标题栏
    windowLess: 0 // 走离屏渲染会导致财付通支付密码输入组件出问题，这里不走离屏渲染
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PHOTO_VIEWER"], {
    type: 'activity',
    title: '查看相册',
    url: 'https://qvideo.qq.com/mixed/pc/photo-viewer.html',
    width: 680,
    height: 680,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_SECOND_INDENTITY_EDITOR"], {
    type: 'activity',
    title: '第二身份',
    url: 'https://qvideo.qq.com/mixed/pc/second-identity-editor.html',
    width: 360,
    height: 170,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_USER_PROFILE_CHARM"], {
    type: 'activity',
    title: '魅力值贡献榜',
    url: 'https://qvideo.qq.com/mixed/pc/user-profile-charm.html',
    width: 360,
    height: 420,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_USER_PROFILE_FOLLOW"], {
    type: 'activity',
    title: '我的关注',
    url: 'https://qvideo.qq.com/mixed/pc/user-profile-follow.html',
    width: 360,
    height: 420,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_USER_PROFILE_FOLLOWME"], {
    type: 'activity',
    title: '关注我的',
    url: 'https://qvideo.qq.com/mixed/pc/user-profile-followme.html',
    width: 360,
    height: 420,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PHONE_VERIFICATION"], {
    type: 'activity',
    title: '手机认证',
    url: 'https://qvideo.qq.com/mixed/pc/phone-verification.html',
    width: 480,
    height: 310,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_VOICE_COVER"], {
    type: 'activity',
    title: '语音封面',
    url: 'https://qvideo.qq.com/mixed/pc/voice-cover.html',
    width: 360,
    height: 480,
    pageShadow: true
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_LEVEL"], {
    // type: 'layer',
    type: 'activity',
    title: '我的等级',
    url: 'https://qvideo.qq.com/mixed/pc/level.html',
    width: 376,
    height: 476
    // initHide: false,
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_TASK"], {
    // type: 'layer',
    type: 'activity',
    title: '任务',
    url: 'https://qvideo.qq.com/mixed/pc/task.html',
    width: 485,
    height: 476
    // initHide: false,
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_PRIVILEGE"], {
    type: 'activity',
    title: '爵位',
    url: 'https://qvideo.qq.com/mixed/pc/privilege.html',
    width: 376,
    height: 476
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_APITEST"], {
    type: 'activity',
    title: '爵位',
    url: 'https://qvideo.qq.com/mixed/pc/apitest.html',
    width: 800,
    height: 600
}), _defineProperty(_names$HY_USER_PROFIL, __WEBPACK_IMPORTED_MODULE_0__names__["HY_BADGE_LIST"], {
    type: 'activity',
    title: '勋章',
    url: 'https://qvideo.qq.com/mixed/pc/user-profile-badge-list.html',
    width: 360,
    height: 460,
    pageShadow: true
}), _names$HY_USER_PROFIL);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g = typeof window == 'undefined' ? {} : window;(function (global, factory) {
    if (!global.JSPushEvent) {
        global.JSPushEvent = factory(global);
    }
    if (typeof module !== 'undefined' && module && module.exports) {
        module.exports = global.JSPushEvent;
    }
})(g, function (global) {
    'use strict';

    var registeredNames = [];

    function JSPushEvent() {
        EventEmitter.call(this);
    }

    inheritPrototype(JSPushEvent, EventEmitter);

    JSPushEvent.prototype.$on = function (eventName, cb) {
        if (!eventName) {
            throw new Error('JSPushEvent.$on requires an event name');
        }
        if (typeof eventName !== 'string') {
            throw new Error('the event name of JSPushEvent.$on must be a string');
        }
        if (!isFunction(cb)) {
            throw new Error('the callback of JSPushEvent.$on must be a function');
        }

        this.on(eventName, cb);
        if (registeredNames.indexOf(eventName) === -1) {
            registeredNames.push(eventName);
            register(eventName);
        }
    };

    JSPushEvent.prototype.$emit = function (eventName, data) {
        if (!eventName) {
            throw new Error('JSPushEvent.$emit requires an event name');
        }
        if (typeof eventName !== 'string') {
            throw new Error('the event name of JSPushEvent.$emit must be a string');
        }
        try {
            data = JSON.parse(data);
            this.emit(eventName, data);
        } catch (error) {
            this.emit(eventName, data);
        }
        // if (!data) {
        //     this.emit(eventName, data);
        // } else {
        //     console.log('eventName: ', eventName, ' data: ', JSON.parse(data))
        //     this.emit(eventName, JSON.parse(data));
        // }
    };

    JSPushEvent.prototype.$off = function (eventName) {
        if (!eventName) {
            throw new Error('JSPushEvent.$off requires an event name');
        }
        if (typeof eventName !== 'string') {
            throw new Error('the event name of JSPushEvent.$off must be a string');
        }

        this.off(eventName);
        unRegister(eventName);
    };

    function register(name) {
        window.external && window.external.RegisterJsPush && window.external.RegisterJsPush(name);
    }

    function unRegister(name) {
        window.external && window.external.UnRegisterJsPush && window.external.UnRegisterJsPush(name);
    }

    function isFunction(fn) {
        return Object.prototype.toString.call(fn) === '[object Function]';
    }

    function inheritPrototype(subType, superType) {
        var prototype = Object(superType.prototype);
        prototype.constructor = subType;
        subType.prototype = prototype;
    }

    var jsPushEvent = new JSPushEvent();

    if (!global.OnJsPushCallback) {
        global.OnJsPushCallback = function (key, data) {
            if (registeredNames.indexOf(key) !== -1) {
                jsPushEvent.$emit(key, data);
                return true;
            }
            return false;
        };
    }

    /************class EventEmitter***************/
    function EventEmitter() {}

    var proto = EventEmitter.prototype;

    proto.on = alias('addListener');
    proto.off = alias('removeListener');
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt),
            listenerIsWrapped = (typeof listener === 'undefined' ? 'undefined' : _typeof(listener)) === 'object',
            key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt),
            response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents(),
            response,
            key;

        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        } else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt),
            index,
            key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt),
            response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt),
            listeners,
            listener,
            i,
            key,
            response;
        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt),
            index,
            key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        } else {
            return true;
        }
    };

    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    return jsPushEvent;
});

/*****test*****/

/*JSPushEvent.$on('GetHongbaoList', function(data) {
alert(JSON.stringify(data) + ' 1');
});

JSPushEvent.$on('GetHongbaoList', function(data) {
alert(JSON.stringify(data) + ' 2');
});*/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function cmp (a, b) {
    var pa = a.split('.');
    var pb = b.split('.');
    for (var i = 0; i < 3; i++) {
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    return 0;
};


/***/ })
/******/ ]);
});